<template>
  <div class="PublicityDetail3">    
    <h3>【保护个人信息谨防网络诈骗】金融知识普及系列之“帮信罪”知多少</h3>
    <img :src="require('../images/ic_publicity_detail3_1.png')"/>
    <br/>
    <div class="no-indent">一、帮助信息网络犯罪活动罪，俗称“帮信罪”，是刑法修正案（九）增设的一种新型网络犯罪。我国刑法第二百八十七之二规定，明知他人利用信息网络实施犯罪，为其犯罪提供互联网接入、服务器托管、网络存储、通讯传输等技术支持，或者提供广告推广、支付结算等帮助，情节严重的，处三年以下有期徒刑或者拘役，并处或者单处罚金。根据前述规定，王某甲和王某乙出借名下账户给朱某，用于收取电信诈骗所得款项，已涉嫌帮信罪。</div>
    <br/>
    <div class="no-indent">二、日常生活实践中，有些人往往存在侥幸心理，觉得自己并没有参与到直接犯罪中去，便认为自己不会触犯到法律，殊不知自己已经触犯了法律，成为了帮凶。那么，如何绑定自己是否沟通”帮信罪“？判断标准有三个方面：</div>
    <p>1、是否明知他人在利用信息网络实施犯罪；</p>
    <p>2、是否提供了网络相关技术支持、广告推广、支付结算等帮助行为；</p>
    <p>3、情节是否达到严重的标准。</p>
    <div class="title">案例启示：</div>
    <p>现实生活中，不少人因为讲不完的“朋友 义气”、抹不开的“亲情脸面”、放不下的“ 蝇头小利”,将自己的银行账户、身份证件出借给朋友亲戚，最终自吃苦果。</p>
    <br/>
    <div>一、要认清租借账户的用途和本质。</div>
    <p>租借他人账户，一般而言，均出于某些不可告人的目的，如规避监管、隐瞒资金用途和流向、切断犯罪线索等，这些行为，往往涉嫌违法犯罪；而为这些违法犯罪行为提供帮助的，很有可能也会涉嫌违法犯罪，如前述的帮信罪。</p>
    <br/>
    <div>二、要坚决向出租出借账户行为说“不”</div>
    <p>无论是亲情还是友情义气，在违法犯罪签名，均要恪守本心，守住底线，坚决拒绝亲戚朋友的租借账户要求</p>
    <br/>
    <div>三、要树立正确的价值观。</div>
    <p>要牢记天使不会突然掉馅饼，时刻警惕不劳而获的不良思想，拒绝因蝇头小利出租出借本人账户</p>
    <br/>
    <div>四、要加强法律意识的培养。</div>
    <p>要加强法律学习，了解罪与非罪、法与非法，确保行为的合法性，做到依法行动，合法维权。</p>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail3'
};
</script>

<style scoped lang="less">
.PublicityDetail3 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 45px;
  }

  .subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: 500;
    text-indent: 2em;

    &.no-indent {
      text-indent: unset;
    }
  }

  div {
    text-align: left;
  }

  p {
    text-indent: 2em;
    margin: 15px 0 0;
    text-align: left;
    margin-block-end: 0;
    margin-block-start: 0;
  }

  img {
    width: 50%;
    margin-top: 30px;
    align-self: center;
  }

  p + img,
  .subtitle + img {
    margin-left: 2em;
  }

  img + p {
    margin-top: 15px;
  }

  img + .title,
  p + .title {
    margin-top: 60px;
  }

  .title + .subtitle,
  img + .subtitle {
    margin-top: 15px;
  }

  p + .subtitle {
    margin-top: 45px;
  }
}
</style>
